import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { usePatientReflectionOverviewConnected } from '@grow-therapy-team/seedling-components';

import { useTrackEvent } from '../../segment/segment';
import { EventTypeEnum } from '../../segment/types';
import { roomAtom } from '../../video-sdk';
import { ReflectionTopicsDrawer } from './ReflectionTopicsDrawer';
import { useHandleReflectionTopicCompletionCallback } from './useHandleReflectionTopicCompletionCallback';

export function ReflectionTopicsDrawerWrapper() {
  const { patientShortId } = useParams();
  const isInSession = !!useAtomValue(roomAtom);
  const { userViewed } = useTrackEvent();
  const handleReflectionTopicCompletion = useHandleReflectionTopicCompletionCallback();

  const { title, content, goToPreviousPatientReflectionView, hasPreviousPatientReflectionView } =
    usePatientReflectionOverviewConnected({
      patientShortId: patientShortId ?? '',
      onUpdateTopicCompletionStatusSuccess: handleReflectionTopicCompletion,
    });

  const onClickBackButton = hasPreviousPatientReflectionView ? goToPreviousPatientReflectionView : undefined;

  useEffect(
    function trackReflectionTopicsViewed() {
      userViewed(EventTypeEnum.REFLECTION_TOPICS_VIEWED, {
        patientShortId: patientShortId ?? '',
        inSession: isInSession,
      });
    },
    [patientShortId, userViewed, isInSession],
  );

  return <ReflectionTopicsDrawer title={title ?? ''} content={content} onClickBackButton={onClickBackButton} />;
}
